import React from 'react';
import { Image, Text } from '@chakra-ui/react';
import Plugin, { PluginProps } from '../Plugin';

const Picture = (props: PluginProps) => {
  const { content } = props;
  if (!content.data.src) {
    return null;
  }
  const imageProps = content.data.props;
  if (imageProps.alignment) {
    if (imageProps.alignment === 'right') {
      imageProps.marginLeft = 'auto';
      imageProps.marginRight = 0;
    } else if (imageProps.alignment === 'left') {
      imageProps.marginRight = 'auto';
      imageProps.marginLeft = 0;
    } else {
      imageProps.marginLeft = 'auto';
      imageProps.marginRight = 'auto';
    }
  }
  const captionText = imageProps.caption_text;
  const altText = imageProps.alt_text;
  const linkUrl = imageProps.link_url;
  const linkTarget = imageProps.link_target;
  
  const ImageComponent = () => (
    <figure>
      <Image style={{ ...imageProps }} src={content.data.src} alt={altText ?? ''} />
      <Text
        as="figcaption"
        size="sm"
        style={{ textAlign: imageProps.alignment }}
      >
        {captionText}
      </Text>
    </figure>
  );
  
  if (linkUrl) {
    const linkProps: any = { href: linkUrl };
    
    // respect link target from cms
    if (linkTarget === '_blank') {
      linkProps.target = '_blank';
      linkProps.rel = 'noopener noreferrer';
    } else {
      linkProps.target = '_self';
    }
    
    return (
      <a {...linkProps}>
        <ImageComponent />
      </a>
    );
  }
  return <ImageComponent />;
};

export default Picture;
